"use strict";
// @ts-ignore
try {
    self['workbox:strategies:6.4.1'] && _();
}
catch (e) { }
